export const FRONTEND_STATE_SEARCH_SHOW = 'FRONTEND_STATE_SEARCH_SHOW';
export const FRONTEND_STATE_SEARCH_HIDE = 'FRONTEND_STATE_SEARCH_HIDE';
export const FRONTEND_STATE_SEARCH_SET_SEARCH_TEXT = 'FRONTEND_STATE_SEARCH/SET_SEARCH_TEXT';
